import React, { Component } from 'react';
import { connect } from 'react-redux';
import surveyActions from '../../actions/survey';
import { Col, List, Row, Icon, Spin } from 'antd';
import Flexbox from 'flexbox-react';
import SurveyHeader from '../SurveyHeader/SurveyHeader';
import SurveyFooter from '../SurveyFooter/SurveyFooter';
import Step from '../ResultStep/ResultStep';

const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin/>;

class Result extends Component{
	componentDidMount() {
		surveyActions.getResult();
	}
	
	render() {
		const { result, questions, answers } = this.props;
		if (!(questions && answers && result)) {
			return (
				<Row type='flex' justify='center' align='middle' className='Spin'>
					<Spin indicator={antIcon}/>
				</Row>
			);
		}
		return (
			<Flexbox flexDirection='column'>
				<SurveyHeader/>
				<Row style={{ flex: 1 }} type='flex' justify='center'>
					<Col xs={23} sm={18} span={8}>
						<List
							itemLayout='vertical'
							size='large'
							split={false}
							dataSource={Object.keys(result || {})}
							renderItem={item =>
								<Step id={item}
								      questions={questions}
								      answers={answers}
								      key={item}
								      stepAnswers={result[item]}/>}
						/>
					</Col>
				</Row>
				<SurveyFooter/>
			</Flexbox>
		);
	}
}

const mapStateToProps = ({ survey: { result, questions, answers } }) => {
	return {
		result, questions, answers,
	};
};

export default connect(mapStateToProps)(Result);


// WEBPACK FOOTER //
// ./src/components/Result/Result.js